import React from "react";

const ModalComponent = ({ isOpen, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" />
      <div className="relative z-50 w-[90%] max-w-lg h-[510px] bg-white rounded-xl shadow-xl">
        {children}
      </div>
    </div>
  );
};

export default ModalComponent;
